import { StatusVariant } from '@factorialco/f0-react'
import { PerformanceValueObjectsReviewProcessStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const getStatusMapping = (
  status: PerformanceValueObjectsReviewProcessStatusEnum
): [string, StatusVariant] => {
  switch (status) {
    case 'draft':
      return [i18n.t('performance_process.reviews.review_status.draft'), 'warning']
    case 'scheduled':
      return [i18n.t('performance_process.reviews.review_status.scheduled'), 'info']
    case 'starting':
      return [i18n.t('performance_process.reviews.review_status.starting'), 'warning']
    case 'active':
      return [i18n.t('performance_process.reviews.review_status.active'), 'positive']
    case 'finished':
      return [i18n.t('performance_process.reviews.review_status.finished'), 'neutral']
  }
}
